import { fetchMtrDetail } from '#/api/imsMgmt/settings/mtr/fetchDetail';
import { updateMtr } from '#/api/imsMgmt/settings/mtr/update';

function resolveMtrUpdatedAt(detailEnvelope) {
  const detail = detailEnvelope?.data ?? detailEnvelope;
  return detail?.updatedAt ?? detail?.record?.updatedAt ?? null;
}

/**
 * BOM 儲存後同步物料一對一關聯（不寫入 BOM body）。
 * 換綁：先清舊料 bomId:null，再設新料 bomId。
 */
export async function syncBomLinkedMaterial({
  bomId,
  previousMtrId = null,
  nextMtrId = null,
}) {
  if (!bomId) {
    throw new Error('syncBomLinkedMaterial: bomId is required');
  }

  const prev = previousMtrId || null;
  const next = nextMtrId || null;

  if (prev === next) {
    return;
  }

  if (prev && prev !== next) {
    const prevDetail = await fetchMtrDetail(prev);
    await updateMtr(prev, {
      bomId: null,
      updatedAt: resolveMtrUpdatedAt(prevDetail),
    });
  }

  if (next) {
    const nextDetail = await fetchMtrDetail(next);
    await updateMtr(next, {
      bomId,
      updatedAt: resolveMtrUpdatedAt(nextDetail),
    });
  }
}

export function formatBomSummaryLabel({ code, name, version } = {}) {
  const main = [code, name].filter(Boolean).join(' — ') || '—';
  if (!version) {
    return main;
  }
  return `${main}（${version}）`;
}
